import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { ArrowRight, TrendingUp } from "lucide-react";
import { getFeaturedPartner, resolveImg } from "../adminApi";
import { Reveal, SplitWords } from "../motionHelpers";
import VideoModal from "../../components/VideoModal";

const ytId = (url) => {
  if (!url || typeof url !== "string") return null;
  const s = url.trim();
  if (/^[a-zA-Z0-9_-]{11}$/.test(s)) return s;
  const m = s.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|shorts\/|v\/))([a-zA-Z0-9_-]{11})/);
  return m ? m[1] : null;
};

export default function DuprShowcase() {
  const [fp, setFp] = useState(null);
  useEffect(() => {
    getFeaturedPartner().then(setFp).catch(() => setFp({}));
  }, []);

  if (!fp || !fp.enabled) return null;

  const perks = fp.perks && fp.perks.length ? fp.perks : [];
  const vid = ytId(fp.video_url);
  const poster = resolveImg(fp.poster);

  return (
    <section id="featured-partner" className="bg-sc-cream py-24 md:py-32 relative overflow-hidden">
      <div className="absolute top-10 right-0 select-none pointer-events-none">
        <span className="font-display uppercase text-outline text-[22vw] leading-none">{(fp.name || "PARTNER").toUpperCase()}</span>
      </div>
      <div className="max-w-[1400px] mx-auto px-5 lg:px-8 relative">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <span className="font-grotesk uppercase tracking-[0.3em] text-sc-orange text-sm">{fp.eyebrow || "Featured Partner"}</span>
            {fp.logo && (
              <img src={resolveImg(fp.logo)} alt={fp.name} className="h-12 w-auto mt-4 object-contain" />
            )}
            <h2 className="font-display uppercase text-sc-green text-5xl md:text-7xl leading-[0.9] mt-4">
              <SplitWords text={fp.headline || fp.name || ""} />
            </h2>
            <Reveal delay={0.1}>
              <p className="text-gray-600 text-lg mt-6 max-w-lg font-grotesk">{fp.body}</p>
              {perks.length > 0 && (
                <div className="grid sm:grid-cols-3 gap-4 mt-8">
                  {perks.map((p, i) => (
                    <div key={p.title || i} className="d2-card bg-white p-5 border-b-4 border-sc-lime">
                      <TrendingUp className="w-6 h-6 text-sc-green" />
                      <div className="font-grotesk font-bold text-sc-green mt-3 text-sm uppercase tracking-wide">{p.title}</div>
                      <div className="text-gray-500 text-sm mt-1">{p.desc}</div>
                    </div>
                  ))}
                </div>
              )}
              {fp.cta_label && fp.cta_url && (
                <a href={fp.cta_url} target="_blank" rel="noreferrer" className="btn-green inline-flex items-center gap-3 px-8 py-4 mt-8 text-sm font-bold">
                  {fp.cta_label} <ArrowRight className="w-4 h-4" />
                </a>
              )}
            </Reveal>
          </div>

          {vid && (
            <Reveal delay={0.15}>
              <div className="relative">
                <VideoModal videoId={vid} poster={poster} label={`${fp.name || "Partner"} Highlights`} className="rounded-2xl shadow-2xl" />
              </div>
            </Reveal>
          )}
        </div>
      </div>
    </section>
  );
}
